import { useTheme } from 'foundations-theming/utils';
import { REDUCED_CARD_THUMBNAIL_SIZES } from './ReducedCardTypes';
import { jsx as _jsx } from "react/jsx-runtime";
const ReducedSkeletonThumbnail = ({
  backgroundColor,
  size = 'medium',
  style
}) => {
  const theme = useTheme();
  const thumbnailSize = REDUCED_CARD_THUMBNAIL_SIZES[size];
  const fillColor = backgroundColor ? theme.color[backgroundColor] : theme.color['fill-accent-neutral-subtle-alt'];
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx("svg", {
      height: thumbnailSize,
      style: style,
      version: "1.1",
      viewBox: `0 0 ${thumbnailSize} ${thumbnailSize}`,
      width: thumbnailSize,
      xmlns: "http://www.w3.org/2000/svg",
      children: /*#__PURE__*/_jsx("g", {
        fill: "none",
        fillRule: "evenodd",
        id: "Homepage-optimisations",
        stroke: "none",
        strokeWidth: "1",
        children: /*#__PURE__*/_jsx("g", {
          id: "Homepage-Delete-progress",
          transform: "translate(-939.000000, -449.000000)",
          children: /*#__PURE__*/_jsx("g", {
            id: "Ready-to-jump-back-in",
            transform: "translate(134.000000, 393.000000)",
            children: /*#__PURE__*/_jsx("g", {
              id: "Small",
              transform: "translate(2.000000, 50.000000)",
              children: /*#__PURE__*/_jsx("g", {
                id: "Marketing-Copy-3",
                transform: "translate(803.000000, 0.000000)",
                children: /*#__PURE__*/_jsx("g", {
                  id: "holding-image",
                  transform: "translate(0.000000, 6.000000)",
                  children: /*#__PURE__*/_jsx("rect", {
                    fill: fillColor,
                    height: thumbnailSize,
                    id: "Rectangle-Copy",
                    rx: "3",
                    width: thumbnailSize,
                    x: "0",
                    y: "0"
                  })
                })
              })
            })
          })
        })
      })
    })
  );
};
export default ReducedSkeletonThumbnail;